import { render, staticRenderFns } from "./StoreSplit.vue?vue&type=template&id=607a8cd0&scoped=true&"
import script from "./StoreSplit.vue?vue&type=script&lang=ts&"
export * from "./StoreSplit.vue?vue&type=script&lang=ts&"
import style0 from "./StoreSplit.vue?vue&type=style&index=0&id=607a8cd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a8cd0",
  null
  
)

export default component.exports